import { seatsOfTeam, type TeamId, type Totals } from '../game/match';
import type { SeatPlayer, Teams } from '../shared/schemas';
import { Avatar, Name, teamAvatarFill } from './ui';

/** What finishing now would mean: the would-be winners and the Guaa score. */
export function FinishPreview({
  teams,
  seats,
  t,
  leader,
  deals,
}: {
  teams: Teams;
  seats: SeatPlayer[];
  t: Totals;
  leader: TeamId | null;
  deals: number;
}) {
  const side = (id: TeamId) => (
    <div className={`flex min-w-0 flex-1 flex-col items-center ${leader && leader !== id ? 'opacity-60' : ''}`}>
      <span className="flex max-w-full items-center gap-1.5 text-xs font-bold text-ink">
        <span className="h-2 w-2 shrink-0 rounded-full" style={{ background: teams[id].color }} aria-hidden />
        <span className="truncate">{teams[id].name}</span>
      </span>
      <span className="font-display text-4xl leading-none font-extrabold tabular-nums" style={{ color: teams[id].color }}>
        {id === 'A' ? t.guaaA : t.guaaB}
      </span>
      <span className="text-[10px] font-bold tracking-wider text-ink-soft uppercase">Guaa</span>
    </div>
  );

  return (
    <div className="space-y-3">
      <div className="rounded-2xl bg-white p-4 ring-1 ring-ink/10">
        <p className="mb-3 text-base font-bold text-ink">
          {leader ? (
            <>
              <span style={{ color: teams[leader].color }}>{teams[leader].name}</span> will win 🏆
            </>
          ) : (
            <>It will be a tie 🤝</>
          )}
        </p>
        {leader && (
          <div className="mb-3 flex justify-center gap-4">
            {seatsOfTeam(leader).map((s) => (
              <div key={s} className="flex min-w-0 flex-col items-center">
                <div className="relative">
                  <span aria-hidden className="absolute -top-4 left-1/2 -ml-2.5 text-xl">
                    👑
                  </span>
                  <Avatar name={seats[s]!.name} avatarKey={seats[s]!.avatarKey} size={48} ring="var(--color-gold)" fill={teamAvatarFill(teams[leader].color)} />
                </div>
                <Name className="mt-1 max-w-24 truncate text-xs font-semibold text-ink">{seats[s]!.name}</Name>
              </div>
            ))}
          </div>
        )}
        <div className="flex items-center gap-2 border-t border-ink/10 pt-3">
          {side('A')}
          <span className="font-display text-sm font-bold text-ink-soft" aria-hidden>
            vs
          </span>
          {side('B')}
        </div>
      </div>
      <p>
        After {deals} deals. Changed your mind later? <span className="font-semibold text-ink">Undo last</span> reopens the match.
      </p>
    </div>
  );
}
